import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { captureStack1fzi4aczwc4hg as captureStack } from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  RuntimeException1r3t0zl97011n as RuntimeException,
} from '../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        this.serialVersionUID_1 = 4231196759387994100n;
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
function init_kotlinx_datetime_DateTimeFormatException(_this__u8e3s4) {
  captureStack(_this__u8e3s4, _this__u8e3s4.$throwableCtor_4);
}
var DateTimeFormatExceptionClass;
function DateTimeFormatException() {
  if (DateTimeFormatExceptionClass === VOID) {
    class $ extends IllegalArgumentException() {
      static new_kotlinx_datetime_DateTimeFormatException_3779ts_k$() {
        var $this = this.new_kotlin_IllegalArgumentException_pv5o3f_k$();
        init_kotlinx_datetime_DateTimeFormatException($this);
        return $this;
      }
      static new_kotlinx_datetime_DateTimeFormatException_hir7ye_k$(message) {
        var $this = this.new_kotlin_IllegalArgumentException_sfqr8_k$(message);
        init_kotlinx_datetime_DateTimeFormatException($this);
        return $this;
      }
      static new_kotlinx_datetime_DateTimeFormatException_zeum51_k$(message, cause) {
        var $this = this.new_kotlin_IllegalArgumentException_afpr0i_k$(message, cause);
        init_kotlinx_datetime_DateTimeFormatException($this);
        return $this;
      }
    }
    initMetadataForClass($, 'DateTimeFormatException', $.new_kotlinx_datetime_DateTimeFormatException_3779ts_k$);
    DateTimeFormatExceptionClass = $;
  }
  return DateTimeFormatExceptionClass;
}
var CompanionClass_0;
function Companion_0() {
  if (CompanionClass_0 === VOID) {
    class $ {
      constructor() {
        this.serialVersionUID_1 = -3207806170214997982n;
      }
    }
    initMetadataForCompanion($);
    CompanionClass_0 = $;
  }
  return CompanionClass_0;
}
var Companion_instance_0;
function Companion_getInstance_0() {
  return Companion_instance_0;
}
function init_kotlinx_datetime_DateTimeArithmeticException(_this__u8e3s4) {
  captureStack(_this__u8e3s4, _this__u8e3s4.$throwableCtor_3);
}
var DateTimeArithmeticExceptionClass;
function DateTimeArithmeticException() {
  if (DateTimeArithmeticExceptionClass === VOID) {
    class $ extends RuntimeException() {
      static new_kotlinx_datetime_DateTimeArithmeticException_yhdxkd_k$() {
        var $this = this.new_kotlin_RuntimeException_29f9zq_k$();
        init_kotlinx_datetime_DateTimeArithmeticException($this);
        return $this;
      }
      static new_kotlinx_datetime_DateTimeArithmeticException_17ykny_k$(message, cause) {
        var $this = this.new_kotlin_RuntimeException_iani9z_k$(message, cause);
        init_kotlinx_datetime_DateTimeArithmeticException($this);
        return $this;
      }
    }
    initMetadataForClass($, 'DateTimeArithmeticException', $.new_kotlinx_datetime_DateTimeArithmeticException_yhdxkd_k$);
    DateTimeArithmeticExceptionClass = $;
  }
  return DateTimeArithmeticExceptionClass;
}
var CompanionClass_1;
function Companion_1() {
  if (CompanionClass_1 === VOID) {
    class $ {
      constructor() {
        this.serialVersionUID_1 = 1159315966274264801n;
      }
    }
    initMetadataForCompanion($);
    CompanionClass_1 = $;
  }
  return CompanionClass_1;
}
var Companion_instance_1;
function Companion_getInstance_1() {
  return Companion_instance_1;
}
function init_kotlinx_datetime_IllegalTimeZoneException(_this__u8e3s4) {
  captureStack(_this__u8e3s4, _this__u8e3s4.$throwableCtor_4);
}
var IllegalTimeZoneExceptionClass;
function IllegalTimeZoneException() {
  if (IllegalTimeZoneExceptionClass === VOID) {
    class $ extends IllegalArgumentException() {
      static new_kotlinx_datetime_IllegalTimeZoneException_5l43st_k$() {
        var $this = this.new_kotlin_IllegalArgumentException_pv5o3f_k$();
        init_kotlinx_datetime_IllegalTimeZoneException($this);
        return $this;
      }
      static new_kotlinx_datetime_IllegalTimeZoneException_ascxr7_k$(message) {
        var $this = this.new_kotlin_IllegalArgumentException_sfqr8_k$(message);
        init_kotlinx_datetime_IllegalTimeZoneException($this);
        return $this;
      }
      static new_kotlinx_datetime_IllegalTimeZoneException_bkml2m_k$(cause) {
        var $this = this.new_kotlin_IllegalArgumentException_8emk6d_k$(cause);
        init_kotlinx_datetime_IllegalTimeZoneException($this);
        return $this;
      }
      static new_kotlinx_datetime_IllegalTimeZoneException_2m6qr6_k$(message, cause) {
        var $this = this.new_kotlin_IllegalArgumentException_afpr0i_k$(message, cause);
        init_kotlinx_datetime_IllegalTimeZoneException($this);
        return $this;
      }
    }
    initMetadataForClass($, 'IllegalTimeZoneException', $.new_kotlinx_datetime_IllegalTimeZoneException_5l43st_k$);
    IllegalTimeZoneExceptionClass = $;
  }
  return IllegalTimeZoneExceptionClass;
}
//region block: init
Companion_instance = new (Companion())();
Companion_instance_0 = new (Companion_0())();
Companion_instance_1 = new (Companion_1())();
//endregion
//region block: exports
export {
  DateTimeArithmeticException as DateTimeArithmeticException3b9ehoczpp1e2,
  DateTimeFormatException as DateTimeFormatException2onfeknbywaob,
  IllegalTimeZoneException as IllegalTimeZoneException2q01rvpc2etsw,
};
//endregion

//# sourceMappingURL=Exceptions.mjs.map
